import { Container } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

export default function OverviewFeaturedStats(props){
    const site = props.global.site
    const auth = props.global.auth

    const arr = auth && auth.name ? auth.name.split(' ') : []

    const [contactId, setContactId] = useState(null)
    const [data, setData] = useState({ 
        firstname: arr[0],  
        lastname: arr[1],
    })

    const authContactId = auth.site_user ? auth.contactId : null
    const { data: contactAccount } = request.contacts.swrAccount(authContactId)

    useEffect(() => {
        if (contactAccount?.contact_id) {
            setData({ 
                firstname: contactAccount?.contact?.profile?.firstname || "",  
                lastname: contactAccount?.contact?.profile?.lastname || ""
            })
            setContactId(parseInt(contactAccount.contact_id))
        }
    }, [contactAccount])

    async function handleUserBadge() {
        if (auth.site_user) {
            await request.tracker.setBadge(auth.contactId)  
        }
    }

    useEffect(() => {
        if (auth.site_user) {
            const timeout = setTimeout(() => {
                handleUserBadge()
            }, 500)

            return () => clearTimeout(timeout)
        }
    }, [auth])

    const { data: iqPoints, isLoading: loadingIQ } = request.stats.IQPoints(contactId || '')
    const { data: badgesEarned, isLoading: loadingBadges } = request.stats.badgesEarned(contactId || '')
    const { data: reviewsGiven, isLoading: loadingReviews } = request.stats.reviewsGiven(contactId || '')

    const point = loadingIQ ? '...' : (iqPoints?.points ?? 0)
    const badges = loadingBadges ? '...' : (badgesEarned?.points ?? 0)
    const reviews = loadingReviews ? '...' : (reviewsGiven?.points ?? 0)

    return (
        <div className="overview-feat-stats">
            <Container className="pb-5">
                <h2 className="text-center font-weight-bold mt-3 mb-5 pb-3">
                    Way to go {data.firstname} You’re an Ace Attendee!
                </h2>
                <div className="feat-list text-center my-4 pt-4">
                    <div>
                        <p className="icon-text">
                            <img src="/images/learnandearn/img-wellness-iq-points.svg" />
                            <span>{point}</span>
                        </p>
                        <p className="icon-title">Wellness IQ Points</p>
                    </div>
                    <div>
                        <p className="icon-text">
                            <img src="/images/learnandearn/img-badges-earned.svg" />
                            <span>{badges}</span>
                        </p>
                        <p className="icon-title">Badges Earned</p>
                    </div>
                    {/* 
                    <div>
                        <p className="icon-text">
                            <img src="/images/learnandearn/img-events-attended.svg" />
                            <span>{events}</span>
                        </p>
                        <p className="icon-title">Events Attended</p>
                    </div>
                    <div>
                        <p className="icon-text">
                            <img src="/images/learnandearn/img-reviews-given.svg" />
                            <span>{reviews}</span>
                        </p>
                        <p className="icon-title">Reviews Given</p>
                    </div> 
                    */}
                </div>
            </Container>
            <hr className="divider mx-auto " />
            <style jsx>{`
                .icon-text span {
                    font-size: 3rem;
                    display: inline-block;
                    margin-left: 1.5rem;
                    line-height: 0;
                    font-weight: 600;
                }
                .icon-text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .icon-title {
                    font-size: 1.13rem;
                }
                .overview-feat-stats .feat-list {
                    display: grid !important;
                    align-items: center;
                    grid-template-columns: repeat(auto-fit, minmax(217px, 1fr));
                    grid-gap: 20px;
                    justify-content: center;
                }
            `}</style>
        </div>
    )
}
